import React from 'react';

export default ({ label, value, className }) => (
	<div className={className || 'col-6'}>
		<strong>{`${label}:`}</strong>
		<p className='text-break'>{value}</p>
	</div>
);
